import CreateOrder from './CreateOrder';

export default CreateOrder;
